module.exports = __webpack_public_path__ + "3193d4a3d786f58852d4562e1ebd2442.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_white_active.png
// module id = 68
// module chunks = 0 1 2 3 4